<template>
    <v-container v-if="tournaments">
      <p class="text-center pb-4" style="font-size:25px;">Mis Torneos</p>
      <v-row
        no-gutters
      >
        <v-col>
        </v-col>

        <v-col>
        </v-col>
        <v-col>
          <v-btn type="button" color="primary" @click="redirect('')" class="mr-4">Crear Torneo</v-btn>
        </v-col>
        <v-col>
          <v-btn type="button" color="primary" @click="redirectArchi()" class="mr-4">Ver Archivados</v-btn>
        </v-col>
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Titulo
        </th>
        <th class="text-center">
          Fecha
        </th>
        <th class="text-center">
          Resultados
        </th>
        <th class="text-center">
          Editar
        </th>
        <th class="text-center">
          Archivar
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in tournaments"
        :key="item.id"
      >
        <td class="text-left" style="width: 1000px">{{ item.title }}</td>
        <td class="text-center">{{ item.start_date }}</td>
        <td class="text-center">
          <v-btn type="button" color="primary" @click="redirectR(item.id)" class="mr-4">
            Ver Resultados
          </v-btn>
        </td>
        <td class="text-center">
          <v-btn type="button" color="primary" @click="redirect(item.id)" class="mr-4">
            Editar
          </v-btn>
        </td>
        <td class="text-center">
          <v-btn type="button" color="primary" @click="redirectA(item.id)" class="mr-4">
            Archivar
          </v-btn>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";

  export default {
    apollo: {
    tournaments: {query: gql` {
       tournaments:myTournaments{
        id
        title
        start_date:startDateFormated
      }
    }`
    },
  },
    name:"MyTournamentChess",
    data () {
      return {
        tournaments: null
      }
    },
    methods:{
      redirect(id){
        if(id){
          window.location.href = '/crear_torneo/' + id
        } else {
          window.location.href = '/crear_torneo'
        }

      },
      redirectR(id){
        window.location.href = '/resultados_torneo/' + id
      },
      redirectA(id){
        window.location.href = '/archive_tournament/' + id
      },
      redirectArchi(){
        window.location.href = '/mis_torneos_archivados/'
      }
    }
  }
</script>

